import {
  LOGIN_SUCCESS,
  LOGOUT,
  REFRESH_USER_PERMISSIONS,
  SET_COMPANY,
  SET_FINANCIAL_YEAR
} from "../actionTypes";

const initialState = {
  isAuthenticated: localStorage.getItem("isAuthenticated") === "true",

  company: JSON.parse(localStorage.getItem("company") || "null"),

  financialYear: JSON.parse(localStorage.getItem("financialYear") || "null"),

  user: JSON.parse(localStorage.getItem("user") || "null"),

  userPermissions: JSON.parse(
    localStorage.getItem("userPermissions") || "null"
  ),

  loginTime: localStorage.getItem("loginTime")
    ? Number(localStorage.getItem("loginTime"))
    : null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS: // Use LOGIN_SUCCESS constant in your switch case
      console.log("action.payload", action.payload);

      localStorage.setItem("isAuthenticated", true);
      localStorage.setItem(
        "user",
        JSON.stringify(action.payload.response.data)
      );
      localStorage.setItem(
        "token",
        JSON.stringify(action.payload.response.token)
      );
      localStorage.setItem("loginTime", Date.now());
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.response.data,
        loginTime: Date.now()
      }; // Store the login time

    case REFRESH_USER_PERMISSIONS:
      // We keep the existing token but update the user profile/permissions
      localStorage.setItem("userPermissions", JSON.stringify(action.payload));
      return { ...state, userPermissions: action.payload };

    case LOGOUT: // Use LOGOUT constant in your switch case
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("loginTime");
      localStorage.removeItem("userPermissions");
      localStorage.removeItem("company");
      localStorage.removeItem("financialYear");
      return { ...state, isAuthenticated: false, user: null, loginTime: null };

    case SET_COMPANY:
      localStorage.setItem("company", JSON.stringify(action.payload));
      return { ...state, company: action.payload };

    case SET_FINANCIAL_YEAR:
      localStorage.setItem("financialYear", JSON.stringify(action.payload));
      return { ...state, financialYear: action.payload };

    default:
      return state;
  }
};

export default authReducer;
